import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from "./components/Home";
import Customers from "./components/Customers";
import Customer from "./components/Customer";
import Notifications from "./components/Notifications";
import Notification from "./components/Notification";
import Login from "./components/Login";
import Setting from "./components/Setting";
import './custom.css';

export default class App extends Component {
  render() {
    return (
      <Layout>
            <Routes>
                <Route exact path='/' element={<Home />} />
                <Route path='/login' element={<Login />} />
                <Route path='/settings' element={<Setting />} />

                <Route path='/customer/new' element={<Customer Id={0} />} />
                <Route path='/customer/edit/:id' element={<Customer Id={1} />} />
                <Route path='/customers' element={<Customers />} />

                <Route path='/notification/new' element={<Notification Id={0} />} />
                <Route path='/notification/edit/:id' element={<Notification Id={1} />} />
                <Route path='/notifications' element={<Notifications />} />
        </Routes>
      </Layout>
    );
  }
}